import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YtbesprechungRoutingModule } from './ytbesprechung-routing.module';
import { YtbesprechungPageComponent } from './page/ytbesprechung-page/ytbesprechung-page.component';
import { YtbesprechungDetailComponent } from './components/ytbesprechung-detail/ytbesprechung-detail.component';
import { SharedModule } from '../../shared/shared.module';
import { MatChipsModule } from '@angular/material/chips';
import { SafePipe } from 'safe-pipe';
import { MatIconModule } from '@angular/material/icon';
import { YtbDetailIconListComponent } from './components/ytb-detail-icon-list/ytb-detail-icon-list.component';

import { MarkdownModule } from 'ngx-markdown';


@NgModule({
  declarations: [YtbesprechungPageComponent, YtbesprechungDetailComponent, YtbDetailIconListComponent],
  imports: [
    CommonModule,
    YtbesprechungRoutingModule,
    SharedModule,
    MarkdownModule,
    MatChipsModule,
    SafePipe,
    MatIconModule
  ]
})
export class YtbesprechungModule { }
